import React from 'react';
import { useIntl } from 'react-intl';
import { Grow } from '@mui/material';
import ListIcon from '@mui/icons-material/List';
import CustomDialog from '../../../Components/Dialog/CustomDialog';
import DetailsContent from './DetailsContent';

const MassiveDetails = function MassiveDetails({
  close,
  setSearchValues,
  removeCustomersFromBatch,
  open = false,
  ObserverWrapper = null,
  searchValues = null,
  campaign = null,
  massive = null,
  templateName = '',
  recipientsCount = 0,
  firstRecipient = null,
  waveSections = [],
}) {
  const intl = useIntl();

  return (
    <CustomDialog
      styles={{
        content: {
          display: 'flex',
          height: '75vh',
          paddingTop: '24px',
          overflow: 'hidden',
        },
      }}
      title={intl.messages.MASSIVE_DETAILS}
      id="massive-details"
      showOnly
      disableActions
      open={open}
      close={close}
      fullWidth
      maxWidth="lg"
      transition={Grow}
      icon={<ListIcon />}
    >
      <DetailsContent
        campaign={campaign}
        massive={massive}
        templateName={templateName}
        filters={massive?.filters ? JSON.parse(massive.filters) : null}
        scheduledOnDate={campaign?.scheduledOn}
        waveSections={waveSections}
        recipientsCount={recipientsCount}
        firstRecipient={firstRecipient}
        removeCustomersFromBatch={removeCustomersFromBatch}
        setSearchValues={setSearchValues}
        searchValues={searchValues}
        ObserverWrapper={ObserverWrapper}
      />
    </CustomDialog>
  );
};

export default MassiveDetails;
